import { handleColorType } from '@quizzach/styles';
import { useTheme } from 'styled-components';

export const Fail = ({
	color,
	size,
	className,
}: {
	color?: string;
	size?: number;
	className?: string;
}) => {
	const theme = useTheme();

	return (
		<svg
			width={size || '42'}
			height={size || '42'}
			viewBox='0 0 42 42'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				d='M11.2929 31.0919C10.9024 30.7013 10.9024 30.0682 11.2929 29.6777L19.7782 21.1924L11.2929 12.7071C10.9024 12.3166 10.9024 11.6834 11.2929 11.2929C11.6834 10.9024 12.3166 10.9024 12.7071 11.2929L21.1924 19.7782L29.6777 11.2929C30.0682 10.9024 30.7014 10.9024 31.0919 11.2929C31.4824 11.6834 31.4824 12.3166 31.0919 12.7071L22.6066 21.1924L31.0919 29.6777C31.4824 30.0682 31.4824 30.7014 31.0919 31.0919C30.7014 31.4824 30.0682 31.4824 29.6777 31.0919L21.1924 22.6066L12.7071 31.0919C12.3166 31.4824 11.6834 31.4824 11.2929 31.0919Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42ZM21 40C31.4934 40 40 31.4934 40 21C40 10.5066 31.4934 2 21 2C10.5066 2 2 10.5066 2 21C2 31.4934 10.5066 40 21 40Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
		</svg>
	);
};
